module.exports = __webpack_public_path__ + "static/media/slider-l6-360.916f1bda.webp";